<template>
  <div class="b-law-exam-report">
    <div
      v-if="isLawyer || nameDisappear"
      class="law-top-header"
    >
      <div class="law-top-header-inner">
        <span class="law-top-header-inner-title text-overflow">{{ topHeaderTitle }}</span>
        <el-button
          v-if="isLawyer"
          :loading="exportLoading"
          class="law-top-header-inner-send"
          @click="handleExportBtn"
        >
          导出报告
        </el-button>
      </div>
    </div>
    <div
      class="body"
      @scroll.passive="segmentScroll"
    >
      <div class="body-inner">
        <div
          v-if="!isLawyer"
          class="law-company-top-body"
        >
          <span class="law-company-top-body-name">{{ topHeaderTitle }}</span>
          <div class="law-company-top-body-line" />
          <span class="law-company-top-body-lawyer">律师事务所提供服务</span>
        </div>
        <report-header
          ref="reportHeader"
          class="report-header"
          :company-id="companyParams.id"
          :name="companyParams.name"
        />
        <div
          ref="segmentControl"
          class="segment-control"
        >
          <el-radio-group
            v-model="currentInfoType"
            size="small"
          >
            <el-radio-button
              v-for="type in infoTypes"
              :key="type.label"
              :label="type.label"
            >
              <i :class="'one one-' + type.icon" />
              {{ type.value }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div
          ref="bodyContent"
          class="body-content"
        >
          <keep-alive>
            <component :is="currentInfoType" />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportHeader from './components/CompanyInfoHeader'
import ReportSummary from './components/ReportSummary'
import ReportBaseInfo from './components/ReportBaseInfo'
import ReportGovernance from './components/ReportGovernance'
import ReportPersonnel from './components/ReportPersonnel'
import ReportIPR from './components/ReportIPR'
import ReportManagement from './components/ReportManagement'
import ReportRisk from './components/ReportRisk'
import appointService from '@/api/appoint'
import lawExamService from '@/service/law-exam'
import { LAW_APPOINT_CONFRIM } from '@/service/copywriting'
import winUtil from '@/utils/win'
import { mapState } from 'vuex'
import Vue from 'vue'
import elementUi from 'element-ui'
Vue.use(elementUi)
import '@/suvery/style/reset.styl'
import '@/suvery/style/common.styl'
import '@/suvery/style/element-theme/index.css'
import '@/suvery/style/element-ui.styl'

export default {
  name: 'BLawExamReport',
  components: {
    ReportHeader,
    ReportSummary,
    ReportBaseInfo,
    ReportGovernance,
    ReportPersonnel,
    ReportIPR,
    ReportManagement,
    ReportRisk
  },
  provide () {
    return {
      companyParams: this.companyParams,
      companyId: this.companyParams.id
    }
  },
  data () {
    return {
      nameDisappear: false,
      currentInfoType: 'ReportSummary',
      appointState: 0, // 0：未预约 1：被我预约 2：被其他律所预约
      exportLoading: false,
      infoTypes: [
        { label: 'ReportSummary', value: '概述', icon: 'menu-clerk' },
        { label: 'ReportBaseInfo', value: '基本信息', icon: 'menu-evidence' },
        { label: 'ReportGovernance', value: '公司治理', icon: 'company' },
        { label: 'ReportPersonnel', value: '劳动人事', icon: 'lawyer' },
        { label: 'ReportIPR', value: '知识产权', icon: 'approve-stamp' },
        { label: 'ReportManagement', value: '公司经营', icon: 'project' },
        { label: 'ReportRisk', value: '涉诉风险', icon: 'warning' }
      ]
    }
  },
  computed: {
    ...mapState('app', {
      isLawyer: state => state.userinfo.userId,
    }),
    companyParams () {
      return this.$route.query
    },
    topHeaderTitle () {
      if (this.isLawyer) {
        return '法治体检' + (this.nameDisappear ? ('：' + this.companyParams.name) : '')
      } else {
        return `关于${this.companyParams.name}法治体检服务报告`
      }
    },
    segmentControlOriginTop () {
      let reportHeader = this.$refs.reportHeader.$el
      let top = reportHeader.offsetTop + reportHeader.offsetHeight
      return top + 20
    },
    isIEBrowser () {
      return winUtil.isIE || winUtil.isEdge
    }
  },
  mounted () {
    this.resetSegmentControl()
  },
  methods: {
    resetSegmentControl () {
      if (this.isIEBrowser) {
        this.$refs.segmentControl.style.top = this.segmentControlOriginTop + 'px'
        this.$refs.segmentControl.style.position = 'fixed'
        this.$refs.bodyContent.style.marginTop = '96px'
      }
    },
    segmentScroll (el) {
      let scrollTop = el.target.scrollTop
      let distance = this.isLawyer ? 70 : 230
      this.nameDisappear = scrollTop > distance

      if (this.isIEBrowser) {
        let offsetY = this.segmentControlOriginTop - scrollTop
        this.$refs.segmentControl.style.top = Math.max(64, offsetY) + 'px'
      }
    },
    // 导出报告
    handleExportBtn () {
      this.exportLoading = true
      let params = { companyId: this.companyParams.id, name: this.companyParams.name }
      lawExamService.generateLawReport(params).then(res => {
        console.log(res,'kkk')
        this.exportLoading = false
        location.href=res.data.url
      })
    },
    getReport (key) {
      lawExamService.exportReport(key).then(res => {
        let data = res.data || {}
        let status = data.downloadStatus
        if (status === 1) {
          setTimeout(() => {
            this.getReport(key)
          }, 1000)
        } else if (status === 2) {
          this.exportLoading = false
          this.exportReport(data)
        } else {
          this.exportLoading = false
          this.$Message.error('导出报告失败')
        }
      }).catch(_ => {
        this.exportLoading = false
      })
    },
    exportReport (data) {
      location.href=data.zipPath
    }
  }
}
</script>

<style lang="stylus" scoped>
$innerWidth = 820px
$topIndex = 1001
.b-law-exam-report
  height 100%
  top: 0px;
  right: 0;
  bottom: 0;
  background-color: #f0f0f0;
  /deep/.el-pagination.small .el-pager li.active{
    color #ed6c00
  }
  /deep/.el-dialog__wrapper, .el-message-box__wrapper{
    padding-left 0
  }
  .law-top-header
    z-index $topIndex
    background-color white
    border-bottom 2px solid #091e4214
    box-sizing border-box
    text-align center
    // position fixed
    height 64px
    width 100%
    &-inner
      width $innerWidth
      height 100%
      margin 0 auto
      display flex
      align-items center
      &-title
        font-size 16px
        font-weight 500
        flex 1
        text-align left
      &-appoint, &-send
        padding 0
        height 32px
        line-height 30px
        width 120px
        text-align center
        font-size 14px
      &-send
        background-color #666666
        color white
  .body
    // padding-top 64px
    height calc(100% - 64px)
    overflow auto
    /deep/.el-radio-group .el-radio-button__orig-radio:checked + .el-radio-button__inner{
      color #666666
    }
    .body-inner
      width $innerWidth
      margin 0 auto
      .law-company-top-body
        height 126px
        &-name
          margin-top 6px
          font-size 26px
          font-weight 500
        &-line
          width 40px
          height 2px
          background-color #ed6c00
          margin 18px 0
      .report-header
        margin 40px 0 20px
      .segment-control
        z-index $topIndex
        padding 20px 0
        width 100%
        background-color  #f7f7f7
        position sticky
        position -webkit-sticky
        top 0
      .body-content
        width 100%
        box-sizing border-box
        background-color #fff
        border-radius 2px
        padding 0px 30px 40px
        margin-bottom 40px

// 单独打开一个界面，不会影响全局
.el-dialog__wrapper,
.el-message-box__wrapper
  padding-left 0
.el-message
  margin-left 0
.el-loading-mask
  z-index 1000
</style>
